import { domain } from 'modules/data';
import { memo } from 'react';

import { BillFooter } from '../BillFooter/BillFooter';
import { POFooter } from '../POFooter/POFooter';
import { FooterProps } from './Footer.types';

export const Footer = memo((props: FooterProps) => {
    const { request, matchingLines } = props;

    if (request.integrationCode === domain.IntegrationCode.NetSuitePO) {
        return <POFooter request={request} matchingLines={matchingLines} />;
    }

    return <BillFooter companyId={request.companyId} currency={request.currency} matchingLines={matchingLines} />;
});

Footer.displayName = 'Footer';
